import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

const localStoragePersister = {
  persistClient: (client) => {
    try {
      localStorage.setItem("REACT_QUERY_OFFLINE_CACHE", JSON.stringify(client));
    } catch (error) {
      console.error("Failed to persist cache", error);
    }
  },
  restoreClient: () => {
    try {
      const cachedData = localStorage.getItem("REACT_QUERY_OFFLINE_CACHE");
      return cachedData ? JSON.parse(cachedData) : undefined;
    } catch (error) {
      console.error("Failed to restore cache", error);
      return undefined;
    }
  },
  removeClient: () => {
    localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
  },
};

// ✅ Ensure queryClient is ready before passing it
if (queryClient) {
  persistQueryClient({
    queryClient,
    persister: localStoragePersister,
  });
}

export default queryClient;
